module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori-828889e273588743d41df88dbcf9605b.webp";